"use client";

import { useEffect } from "react";
import "../lib/i18n";

interface I18nProviderProps {
  children: React.ReactNode;
}

export function I18nProvider({ children }: I18nProviderProps) {
  useEffect(() => {
    // i18n is already initialized in the import above
    // This component ensures the i18n is loaded before rendering children
  }, []);

  return <>{children}</>;
}

